import { createContext, useContext, useState, useEffect } from 'react';

const ThemeContext = createContext(null);

export const ThemeProvider = ({ children }) => {
    const [theme, setTheme] = useState(() => {
        return localStorage.getItem('mactech_theme') || 'dark';
    });
    const [themeToggleEnabled, setThemeToggleEnabled] = useState(true);

    // Admin ayarından tema değiştirme özelliğini kontrol et
    useEffect(() => {
        const fetchSetting = async () => {
            try {
                const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/site-settings/theme-toggle`);
                if (res.ok) {
                    const data = await res.json();
                    setThemeToggleEnabled(data.enabled !== false);
                    if (data.enabled === false && data.forced_theme) {
                        setTheme(data.forced_theme);
                    }
                }
            } catch {}
        };
        fetchSetting();
    }, []);

    useEffect(() => {
        const root = document.documentElement;
        localStorage.setItem('mactech_theme', theme);
        if (theme === 'light') {
            root.classList.add('light');
            root.classList.remove('dark');
        } else {
            root.classList.add('dark');
            root.classList.remove('light');
        }
    }, [theme]);

    const toggleTheme = () => {
        if (!themeToggleEnabled) return;
        setTheme(prev => prev === 'dark' ? 'light' : 'dark');
    };

    return (
        <ThemeContext.Provider value={{ theme, toggleTheme, isDark: theme === 'dark', themeToggleEnabled, setThemeToggleEnabled }}>
            {children}
        </ThemeContext.Provider>
    );
};

export const useTheme = () => {
    const context = useContext(ThemeContext);
    if (!context) {
        throw new Error('useTheme must be used within a ThemeProvider');
    }
    return context;
};
